import { featuresData } from '@/mocks/homeData';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          深度扒皮
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">我们如何保证每一口瓜的品质</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200 rounded-xl p-5 md:p-6 text-center hover:border-accent-300 transition-all group cursor-default"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}